import { render, staticRenderFns } from "./InputText.vue?vue&type=template&id=4ca3e5d8&scoped=true"
import script from "./InputText.vue?vue&type=script&lang=js"
export * from "./InputText.vue?vue&type=script&lang=js"
import style0 from "./InputText.vue?vue&type=style&index=0&id=4ca3e5d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca3e5d8",
  null
  
)

export default component.exports